import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { store } from '../../state/store';
import { getAssessmentPdfUrlThunk } from './getAssessmentPdfUrl.thunk';
import { Button } from '../../components/button/button';
import { Spinner } from '../../components/spinner/spinner';

interface SummaryClinicalNotesPdfProps {
  assessmentId: string;
}
export function SummaryClinicalNotesPdf({
  assessmentId,
}: SummaryClinicalNotesPdfProps) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async (): Promise<void> => {
    setIsLoading(true);
    store
      // TODO: don't call backend straight from component
      .dispatch(getAssessmentPdfUrlThunk(assessmentId))
      .unwrap()
      .then((url: string): void => {
        if (url !== undefined) {
          setIsLoading(false);
          window.open(url, '_blank');
        }
      })
      .catch((error): void => {
        setIsLoading(false);
      });
  };

  return (
    <Grid
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{ mb: 2 }}
    >
      {isLoading ? (
        <Spinner open={isLoading} />
      ) : (
        <Button
          type="submit"
          label={t('assessment.VIEW_CLINICAL_NOTES_PDF')}
          onClick={handleClick}
          variant="contained"
          fullWidth
          color="secondary"
        />
      )}
    </Grid>
  );
}
